import { ServiceForm } from '@/models'
import type { TServicesState } from '@/types/state-types'

export default <TServicesState>{
  serviceForm: new ServiceForm(),
  isServiceFormLoading: false
}
